/**
 * The blend's Feedback page route (PLAN-BLEND-STAGES §F3).
 *
 * `/batches/$batchId/feedback`'s sibling and wired the same way: the page is
 * router-free and takes its navigation as callbacks, so it renders in a test
 * without a memory router. "Print a card" hands the run over as one id under
 * `?blends=`, beside the `?batches=` a batch uses — a print run is a list of
 * beers and a beer is a batch or a blend (D-BS9).
 *
 * No return ticket. This page is reached from the blend and goes back to it,
 * and the blend is the one holding the log's ticket (D-LS8); the batch's
 * Feedback route makes the same call for the same reason.
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { BlendFeedbackPage } from '@/components/blending/blend-feedback';

export const Route = createFileRoute('/blending/$blendId/feedback')({
  component: BlendFeedbackRoute,
});

function BlendFeedbackRoute() {
  const { blendId } = Route.useParams();
  const navigate = useNavigate();
  return (
    // Keyed on the id because the router reuses this component when only the
    // param changes, and the page's hook (and its `drawn` ref) keep what they
    // had across an id change: without the key, one blend's sheets would stand
    // in for the next.
    <BlendFeedbackPage
      key={blendId}
      blendId={blendId}
      onBack={() => {
        void navigate({ to: '/blending/$blendId', params: { blendId } });
      }}
      onPrintCard={() => {
        void navigate({ to: '/batches/tasting-cards', search: { blends: blendId } });
      }}
    />
  );
}
